import {withRouter} from 'react-router';
import {withProps} from 'recompose';
import {query} from 'api';
import BaseArticle from './BaseArticle';

export default BaseArticle
  |> query('getPost', {loadingFullWidth: true})
  |> withProps(
    ({
      match: {
        params: {id},
      },
    }) => ({type: 'articles', id}),
  )
  |> withRouter;
